<template>
  <div
    v-if="brandStore.layout === 'brand-builder'"
    class="min-h-screen h-full bg-[linear-gradient(143.08deg,#F7FBFF_21.45%,#EEF7FF_78.55%)]"
  >
    <TsSection
      :append-class="twMerge('overflow-hidden mb-4', isMobile && 'px-0')"
    >
      <TsBreadcrumb :data="breadcrumbData" />
      <TsTitle
        animate
        :title="brandStore.brandName"
        append-class="before:bg-dewalt mt-4"
      />
    </TsSection>

    <TsSection>
      <TsRow append-class="m-0">
        <TsRow append-class="m-0">
          <TsTabsLinksSelection
            :tabs="tabs"
            :append-class="isMobile ? 'p-0 pb-4' : 'p-0 py-3 ml-0 mt-0'"
            button-class="capitalize"
            bordered
          />
        </TsRow>

      </TsRow>
    </TsSection>
    <TsBrandAbout id="brands-about"></TsBrandAbout>
  </div>

  <TsSection v-else>
    <TsBreadcrumb :data="breadcrumbData" />
    <TsBrandSearchResults search-type="brand-search"></TsBrandSearchResults>
  </TsSection>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

const TsBreadcrumb = defineAsyncComponent(() => import('~/components/molecules/TsBreadcrumb.vue'));
const TsTabsLinksSelection = defineAsyncComponent(() => import('~/components/molecules/TsTabsLinksSelection.vue'));
const TsBrandAbout = defineAsyncComponent(() => import('~/components/organisms/TsBrandAbout.vue'));
const TsBrandSearchResults = defineAsyncComponent(() => import('~/components/organisms/TsBrandSearchResults.vue'));

const { isMobile } = useDevice();
const algoliaStore = useAlgoliaStore();
const builderStore = useBuilderStore();
const brandStore = useBrandStore();
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  algoliaStore.setCurrentFlowParams("brand-search", undefined, undefined);
});

await setActiveComponent();
definePageMeta({
  layout: "brand-plp",
});

async function setActiveComponent() {
  brandStore.brandSlug = route.params.brandName;
  brandStore.brandName = useCapitalize(route.params.brandName);

  let brandBuilder = false;

  if (builderStore.brands.length <= 0) {
    await builderStore.fetchAllBrands();
  }

  for (let index = 0; index < builderStore.brands.length; index++) {
    if (
      brandStore.brandSlug ===
      builderStore.brands[index].data.url?.split('/')?.at(-1)
    ) {
      brandBuilder = true;
    }
  }

  if (brandBuilder) {
    brandStore.layout = "brand-builder";
    brandStore.activeTab = "about";
  } else {
    brandStore.layout = "brand-plp";
  }
}

const prevRoute = ref(
  router.options.history &&
    router.options.history.state &&
    router.options.history.state.back
    ? router.options.history.state.back
    : undefined
);

const breadcrumbData = computed(() => {
  const prevRouteLabel = prevRoute.value
    ? String(prevRoute.value).includes("/product/")
      ? "product"
      : ""
    : "";
  return [
    { text: useTranslation("home", "Thuis"), link: "/" },
    {
      text: prevRouteLabel || useTranslation("productAttribute22", "Merks"),
      link: prevRouteLabel ? prevRoute.value : getBrandSlug(),
    },
    { text: useCapitalize(brandStore.brandSlug.replaceAll("-", " ")) },
  ];
});

const tabs = [
  {
    label: useTranslation("about", "Over"),
    icon: "mingcute:home-3-line",
    link: getBrandSlug(brandStore?.brandSlug),
  },
  {
    label: useTranslation("products", "Producten"),
    icon: "codicon:tools",
    link: getBrandSlug(brandStore?.brandSlug, "products"),
  },
  {
    label: useTranslation("deals", "Aanbiedingen"),
    icon: "bxs:offer",
    link: getBrandSlug(brandStore?.brandSlug, "deals"),
  },
];

useHead({
  title: `Toolstation | ${useCapitalize(route.params.brandName)}`,
  meta: [
    {
      name: "description",
      content:
        "Discover a wide range of top brands such as DeWalt, Makita, " +
        "Milwaukee, and more at Toolstation. These brands ensure durability & efficiency across products. " +
        "Shop now with us!",
    },
  ],
});
</script>
